// LazyVideo.js
import React, { useRef, useState, useEffect } from 'react';
import { useInView } from 'framer-motion';

const LazyVideo = ({ src, className, ...props }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (isInView) {
      setShouldLoad(true);
    }
  }, [isInView]);

  return (
    <div ref={ref}>
      {shouldLoad ? (
        <video
          src={src}
          autoPlay
          loop
          muted
          playsInline
          className={className}
          {...props}
        />
      ) : (
        // Placeholder to maintain layout until the video loads
        <div className={className} style={{ background: '#000' }} />
      )}
    </div>
  );
};

export default LazyVideo;
